// TODO vuex typings
// @ts-ignore
import { createStore } from 'vuex'

export default createStore({
  state() {
    return {
      oauthType: '',
      oauthState: ''
    }
  },
  mutations: {
    setOAuthType(state: { oauthType: string }, data: string) {
      state.oauthType = data;
    },
    setOAuthState(state: { oauthState: string }, data: string) {
      state.oauthState = data;
    }
  },
})

